<template>
<div>

    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card class="pa-4">
            <v-card-title class="text-h5 pl-6 font-weight-regular"><span>Received Stock</span></v-card-title>
            <v-card-text class="pb-0">
                <v-form ref="form">
                    <v-row>
                        <v-col cols="12">
                            <label class="text-uppercase grey--text font-weight-bold">Expected Delivery Date</label>
                            <div class="read-only-value">{{moment(form.deliveryDate).format('DD MMM YYYY')}}</div>
                        </v-col>
                        <v-col cols="12">
                            <label class="text-uppercase grey--text font-weight-bold">Received Date*</label>
                            <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px" offset-y
                                     transition="scale-transition" v-model="receivedDateMenu">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field class="rounded-0 mt-3" outlined prepend-inner-icon="mdi-calendar-blank-outline"
                                                  readonly v-bind="attrs" v-model="receivedDateFormat" v-on="on" :rules="[v => !!v || 'Received Date required']"/>
                                </template>
                                <v-date-picker @input="receivedDateMenu = false" v-model="form.receivedDate" :min="moment().format('YYYY-MM-DD')"/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12">
                            <label class="text-uppercase grey--text font-weight-bold">Bilty Number</label>
                            <v-text-field outlined v-model="form.biltyNumber" class="mt-3" maxlength="50" counter/>
                        </v-col>
                        <v-col cols="12">
                            <label class="text-uppercase grey--text font-weight-bold">Received Stock*</label>
                            <v-text-field type="number" outlined v-model="form.receivedStock" class="mt-3"
                                          :rules="[v => !!String(v).length || 'Received Stock required', v => (Number(v) > 0) || 'Invalid Received Stock',
                                                   v => Number.isInteger(Number(v)) || 'Invalid Received Stock']"/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="mt-5">
                <v-spacer></v-spacer>
                <v-btn class="text-capitalize white elevation-0" text @click="onCancelPRQStatusDialog">Close</v-btn>
                <v-btn class="primary px-3 text-capitalize" :loading="formLoading" dark @click="handleSubmit">Next</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <AddNewStock :addStockDialog="addStockDialog" @cancel="onCancelAddStock" @saveStock="afterSaveStock"
                 v-if="addStockDialog" :PRQStock="PRQStock" @back="onBackAddStock"/>
    <Snackbar :toaster="toaster"/>
</div>
</template>

<script>
import Constants from "../../Constants/Constants";
import moment from 'moment';
import Snackbar from "../../components/Common/Snackbar";
import {GET_PURCHASE_REQUEST_BY_ID} from "../../graphql/queries/PurchaseRequest";
import AddNewStock from "../../components/Inventory/AddNewStock";
import updateRecord from '../../mixins/updateRecord';
let user = JSON.parse(localStorage.user);
let form = {deliveryDate:'',  receivedDate:moment().format('YYYY-MM-DD'), biltyNumber:'', receivedStock:0, updatedBy:user.id };

export default {
    name: "ChangePRQStatus",
    components: {AddNewStock, Snackbar},
    mixins: [updateRecord],
    props: ['dialog', 'id'],
    apollo: {
        PurchaseRequest: {
            query: GET_PURCHASE_REQUEST_BY_ID,
            fetchPolicy: 'network-only',
            skip () {return !this.id},
            variables(){ return{ id: this.id } },
            result ({data}) {
                Object.copyExistingKeys(this.form = {...form}, data.PurchaseRequest[0]);
                this.purchaseRequest = data.PurchaseRequest[0];
                this.form.receivedStock = data.PurchaseRequest[0].totalQty
            },
        },
    },
    data(){
        return{
            moment, Constants,
            form: {...form},
            formLoading: false,
            receivedDateMenu: false,
            toaster: {enable: false},
            addStockDialog: false,
            purchaseRequest: {},
            PRQStock: []
        }
    },
    computed:{
        receivedDateFormat: {
            get () { return moment(this.form.receivedDate, 'YYYY-MM-DD').format('DD-MM-YYYY') },
            set () { this.form.receivedDate = null }
        },
    },
    methods:{
        handleSubmit(){
            if(this.$refs.form.validate()) this.openStockPopup()
        },
        openStockPopup(){
            this.PRQStock = [{productId: this.purchaseRequest.productId, quantity: this.form.receivedStock}];
            this.addStockDialog = true;
        },
        afterSaveStock(){
            this.addStockDialog = false;
            this.toaster = {enable: true, color: 'green', message: `Stock Added Successfully`};
            this.updatePRQStatus();
        },
        onCancelAddStock(){
            this.addStockDialog = false;
            this.updatePRQStatus();
        },
        onBackAddStock(){
            this.addStockDialog = false;
        },
        async updatePRQStatus(){
            this.formLoading = true;
            let obj = {statusId:Constants.PRQStatuses.Received, ...this.form};
            await this.updateRecord(this.id, obj, 'PurchaseRequest');
            this.toaster = {color:'green', enable:true, message: `Purchase Request status updated Successfully`};
            this.formLoading = false;
            this.closePRQStatusDialog();
        },
        onCancelPRQStatusDialog(){
            this.$emit('cancel', false);
            this.closePRQStatusDialog();
        },
        closePRQStatusDialog(){
            this.$refs.form.resetValidation();
            this.form = {...form};
            this.$emit('update:dialog', false);
            this.$emit('update:id', null);
        }
    }
}
</script>

<style scoped>
.read-only-value{
    padding: 8px 0 0 10px;
    font-size: 16px;
    color: rgba(0,0,0,.87);
}
</style>